const C = require("../constants");
const initial_data = {open: false, data:{id:null, name:'',}};

function ProductVariantsDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.PRODUCT_VARIANTS_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default ProductVariantsDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProductVariantsDialogReducer.js